module.exports = __webpack_public_path__ + "static/media/announcment-boomer.62ac7ef5.svg";